export default {
  text: 'Die Karte wird von Google bereitgestellt. Beim Laden wird deine IP-Adresse an Google übermittelt.',
  buttons: {
    show_map: 'Karte anzeigen',
    retry: 'Erneut versuchen',
  },
  errors: {
    map_unavailable: 'Die Karte konnte nicht geladen werden.',
  },
};
